import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'
import { Themable } from '../../types/themable'
import { rwdMenuSpacingForTitle } from '../../utils/rwdMenuSpacingForTitle'

type ModuleLayoutWrapperProps = Themable

export const ModuleLayoutWrapper = styled.main<ModuleLayoutWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.ds.colors.base.background};
`

type ModuleStickyHeaderProps = Themable

export const ModuleStickyHeader = styled.header<ModuleStickyHeaderProps>`
  width: 100%;
  padding-top: ${Spacing.S24};
  padding-bottom: ${Spacing.S24};
  background-color: ${({ theme }) => theme.ds.colors.base.background};
`

interface HeaderProps {
  withMenuOffset?: boolean
}

export const Header = styled.div<HeaderProps>`
  ${({ withMenuOffset = true }) => withMenuOffset && rwdMenuSpacingForTitle}
`

export const BackButtonWrapper = styled.div`
  margin-right: ${Spacing.S8};
  cursor: pointer;
`

export const HeaderBottomActionsWrapper = styled.div`
  margin-top: ${Spacing.S8};
`

export const SideActions = styled.aside`
  padding-left: ${Spacing.S16};
`
